"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Box = _interopRequireDefault(require("../../elements/Box"));
var _CoreTableView = _interopRequireDefault(require("./CoreTableView"));
var _CoreProps = require("../../utilities/CoreProps");
var _CoreTableUtils = require("./CoreTableUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CoreTable = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    groupedData,
    data: dataArg,
    summary,
    pivotBy,
    groupBy,
    groupByMode,
    columnDefinitions: columnDefinitionsArg,
    columns: columnsArg,
    noRowsText,
    loading,
    showTableHeader,
    showPagination,
    showPageInfo,
    pageSize,
    expanderClassName,
    expanderCircle,
    expanderPlusMinus,
    expanderLessIcon,
    expanderMoreIcon,
    expanderFlare,
    expanderRowColor,
    footerRowColor,
    selectTable,
    keyField,
    defaultExpanded,
    expandedRow,
    defaultSorted,
    hasAggregatedBackgroundColor,
    className,
    striped,
    bordered,
    narrow,
    fullWidth,
    hoverable,
    removeRow,
    updateData,
    autoResetPageIndex,
    filter,
    ...props
  } = _ref;
  const groupedDataArray = groupedData || [];
  const groupedDataItem = {};
  let data = dataArg;
  let columnDefinitions = columnDefinitionsArg;
  // if (groupBy) {
  //   data.sort((a, b) => defaultSortBy(a[groupBy], b[groupBy]));

  //   columnDefinitions = columnDefinitions.map((column) => {
  //     const col = { ...column };
  //     col.sortable = false;
  //     return col;
  //   });

  //   const tempData = [];
  //   let currentGroup = null;
  //   data.forEach((row) => {
  //     if (currentGroup !== row[groupBy]) {
  //       currentGroup = row[groupBy];
  //       const groupRow = {};
  //       Object.keys(row).forEach((prop) => {
  //         groupRow[prop] = null;
  //       });
  //       if (columnDefinitions && columnDefinitions.length > 0) {
  //         groupRow[columnDefinitions[0].accessor] = row[groupBy];
  //         groupRow.rowType = 'row-group';
  //         tempData.push(groupRow);
  //       }
  //     }
  //     tempData.push(row);
  //   });
  //   data = tempData;
  // }

  if (data) {
    groupedDataItem.data = data;
    groupedDataItem.summary = summary;
    groupedDataItem.pivotBy = pivotBy;
    groupedDataItem.groupBy = groupBy;
    groupedDataArray.push(groupedDataItem);
  }
  const tableReference = (0, _react.useRef)();
  const expanderMore = expanderPlusMinus ? 'add' : expanderMoreIcon;
  const expanderLess = expanderPlusMinus ? 'remove' : expanderLessIcon;

  // const filter = (column) => {
  //   const table = tableReference.current;
  //   return table.getFilter(column);
  // };

  (0, _react.useImperativeHandle)(ref, () => ({
    getSelections: () => {
      const table = tableReference.current;
      const selections = table.getSelections();
      return selections;
    }
  }));
  const tableClassNames = (0, _classnames.default)({
    'is-striped': striped,
    'is-bordered': bordered,
    'is-narrow': narrow,
    'is-fullwidth': fullWidth,
    'is-hoverable': hoverable
  });
  const columns = columnDefinitions ? (0, _react.useCallback)((0, _CoreTableUtils.standardColumns)(columnDefinitions, groupBy, expanderFlare, props), [columnsArg, groupBy, expanderFlare]) : columnsArg;
  const fixedLayout = columns.some(col => col.width);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _classnames.default)('core-table-container', className) || undefined
  }, groupedDataArray && columnDefinitions && groupedDataArray.map((group, idx) => {
    const tableIdentifer = `table_groupAccessor_${group.groupAccessor}_${idx}`;
    const {
      summary: summaryItem
    } = group;
    let groupingArray = Array.isArray(group.pivotBy) ? group.pivotBy : group.groupBy;
    if (!Array.isArray(groupingArray)) {
      groupingArray = [];
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      key: tableIdentifer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table-header"
    }, (summaryItem?.summaryText || summaryItem?.title || summaryItem?.data) && /*#__PURE__*/_react.default.createElement(_Box.default, {
      hasRoundedCorners: false,
      className: "table-summary-container",
      title: summaryItem.summaryText || summaryItem.title
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table-summary-item-list"
    }, summaryItem?.data && summaryItem.data.map((header, idx2) => /*#__PURE__*/_react.default.createElement("div", {
      className: "table-summary-item",
      key: `table_header_item_${group.groupAccessor}_${idx}_${idx2}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "table-summary-item-header-name"
    }, header.name), header.name && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, ': ', /*#__PURE__*/_react.default.createElement("span", {
      className: "table-summary-item-header-value"
    }, header.value))))))), /*#__PURE__*/_react.default.createElement(_CoreTableView.default, {
      ref: tableReference,
      tableIdentifer: tableIdentifer,
      autoResetPageIndex: autoResetPageIndex,
      className: tableClassNames,
      noRowsText: noRowsText || 'No data found',
      data: !loading ? group.data : [],
      checkWidth: true,
      groupBy: groupBy,
      pivotBy: pivotBy,
      groupByMode: groupByMode,
      grouping: groupingArray,
      expanded: defaultExpanded,
      columns: columns,
      fixedLayout: fixedLayout,
      expandedRow: typeof expandedRow === 'function' ? row => expandedRow(row) : undefined,
      defaultSorted: defaultSorted,
      minRows: 0,
      selectTable: selectTable,
      keyField: keyField,
      loading: loading,
      showPagination: showPagination,
      showPageInfo: showPageInfo,
      pageSize: !showPagination ? -1 : pageSize,
      showTableHeader: showTableHeader,
      expanderFlare: expanderFlare,
      expanderRowColor: expanderRowColor,
      footerRowColor: footerRowColor,
      expanderClassName: expanderClassName,
      expanderLess: expanderLess,
      expanderMore: expanderMore,
      expanderCircle: expanderCircle,
      hasAggregatedBackgroundColor: hasAggregatedBackgroundColor,
      removeRow: removeRow,
      updateData: updateData,
      filter: filter
      // filterable={true}
    }));
  }));
});
CoreTable.displayName = 'CoreTable';
CoreTable.propTypes = {
  data: _propTypes.default.array,
  className: _propTypes.default.string,
  noRowsText: _propTypes.default.string,
  keyField: _propTypes.default.string,
  selectTable: _propTypes.default.bool,
  expanderCircle: _propTypes.default.bool,
  expanderPlusMinus: _propTypes.default.bool,
  expanderLessIcon: _propTypes.default.string,
  expanderMoreIcon: _propTypes.default.string,
  expanderRowColor: _propTypes.default.string,
  footerRowColor: _propTypes.default.string,
  expanderFlare: _propTypes.default.bool,
  showTableHeader: _propTypes.default.bool,
  showPagination: _propTypes.default.bool,
  showPageInfo: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  groupedData: _propTypes.default.array,
  pivotBy: _propTypes.default.arrayOf(_propTypes.default.string),
  groupBy: _propTypes.default.arrayOf(_propTypes.default.string),
  groupByMode: _propTypes.default.string,
  columns: _propTypes.default.array,
  columnDefinitions: _propTypes.default.array,
  summary: _propTypes.default.object,
  expanderClassName: _propTypes.default.string,
  isExpanded: _propTypes.default.bool,
  filter: _propTypes.default.bool,
  pageSize: _propTypes.default.number,
  hasAggregatedBackgroundColor: _propTypes.default.bool,
  defaultExpanded: _propTypes.default.bool,
  expandedRow: _propTypes.default.func,
  defaultSorted: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    desc: _propTypes.default.bool
  })),
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  }),
  striped: _propTypes.default.bool,
  bordered: _propTypes.default.bool,
  narrow: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  hoverable: _propTypes.default.bool,
  removeRow: _propTypes.default.func,
  updateData: _propTypes.default.func,
  autoResetPageIndex: _propTypes.default.bool
};
CoreTable.defaultProps = {
  showPageInfo: true,
  showTableHeader: true,
  showPagination: true,
  expanderCircle: false,
  loading: false,
  fullWidth: true,
  defaultSorted: [],
  expanderLessIcon: 'expand_less',
  expanderMoreIcon: 'expand_more',
  groupByMode: 'col'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(CoreTable);
//# sourceMappingURL=CoreTable.js.map